<template>
  <div class="flex items-center h-full">
    <slot />
    <span class="ml-2" :class="labelClasses">{{ label }}</span>
  </div>
</template>

<script>

export default {
  name: 'FilterValue',

  props: {
    label: {
      type: String,
      required: true
    },
    labelClasses: {
      type: String,
      default: ''
    }
  }
}
</script>
